import { z } from 'zod';
import { Validation } from '@mews/framework';
import { GuestInHouseReportState } from '@mews-commander/data-access';
import { commonFilterSchema, commontUrlSchema } from '../../../common';
import { activeTabUrlSchema } from '../../../../schema';
import { ReservationsTableColumns } from '../common';
import { FilterValueKey } from './types';

const reservationsReportSpecificFilterSchema = z.object({
    [FilterValueKey.productIds]: z.array(z.string()),
    [FilterValueKey.filterProductsInInterval]: z.coerce.boolean(),
    [FilterValueKey.serviceId]: Validation.String.Required,
    [FilterValueKey.serviceOrderStatus]: z.array(z.nativeEnum(GuestInHouseReportState)),
    [FilterValueKey.visibleColumns]: z.array(z.nativeEnum(ReservationsTableColumns)).optional(),
    [FilterValueKey.customerId]: z.string().nullish(),
});

export const reservationsReportFilterSchema = commonFilterSchema.merge(reservationsReportSpecificFilterSchema);

const transformBooleanFromString = z
    .union([z.enum(['true', 'false']), z.boolean()])
    .transform<boolean>((arg) => (typeof arg === 'string' ? arg === 'true' : arg));

export const reservationsUrlSchema = commontUrlSchema
    .merge(reservationsReportSpecificFilterSchema)
    .merge(activeTabUrlSchema)
    .extend({
        [FilterValueKey.filterProductsInInterval]: transformBooleanFromString,
    })
    .partial()
    .transform((data) => ({
        ...data,
        customerId: data.customerId ?? undefined,
    }));

export type ReservationsFilterValues = z.infer<typeof reservationsReportFilterSchema>;
